export default function isCaptureSupported(): boolean {
  return (
    (document.createElement('input') as unknown as Record<string, unknown>)
      .capture !== undefined
  );
}
